module.exports = __webpack_public_path__ + "img/icon_empty.bfaf49b4.png";